<div class="unassign-zone-container">
    <jjames-card title="Unassign Parking Zone">
        <!-- Loading State -->
        @if (isLoading) {
        <div class="loading-container">
            <p>Loading zone details...</p>
        </div>
        }

        <!-- Confirmation Content -->
        @if (!isLoading) {
        <div class="confirmation-container">
            <!-- Success Alert -->
            @if (successMessage) {
            <jjames-alert type="success" [dismissible]="true" class="alert-spacing">
                {{ successMessage }}
            </jjames-alert>
            }

            <!-- Error Alert -->
            @if (errorMessage) {
            <jjames-alert type="error" [dismissible]="true" class="alert-spacing">
                {{ errorMessage }}
            </jjames-alert>
            }

            <!-- Warning Message -->
            <div class="warning-section">
                <div class="warning-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                </div>
                <div class="warning-content">
                    <h3>Are you sure you want to unassign this parking zone?</h3>
                    <p>This will remove the zone from the current parking space, but the zone will still exist and can
                        be reassigned later.</p>
                </div>
            </div>

            <!-- Zone Information -->
            @if (currentZone) {
            <div class="zone-info">
                <h4>Zone Information</h4>
                <div class="info-grid">
                    <div class="info-item">
                        <label>Name:</label>
                        <span>{{ currentZone.name || 'N/A' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Description:</label>
                        <span>{{ currentZone.description || 'No description' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Capacity:</label>
                        <span>{{ currentZone.capacity || 0 }} spaces</span>
                    </div>
                    <div class="info-item">
                        <label>Governance Type:</label>
                        <span>{{ currentZone.governanceType || 'N/A' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Address:</label>
                        <span>{{ getZoneAddressString() }}</span>
                    </div>
                    @if (currentZone.id) {
                    <div class="info-item">
                        <label>Zone ID:</label>
                        <span class="zone-id">{{ currentZone.id }}</span>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- Action Buttons -->
            <div class="form-actions">
                <jjames-button type="button" variant="secondary" (click)="onCancel()" [disabled]="isUnassigning">
                    Cancel
                </jjames-button>

                <jjames-button type="button" variant="primary" class="unassign-button" (click)="onConfirmUnassign()"
                    [disabled]="isUnassigning">
                    {{ isUnassigning ? 'Unassigning...' : 'Unassign Zone' }}
                </jjames-button>
            </div>
        </div>
        }
    </jjames-card>
</div>